module.exports = __webpack_public_path__ + "img/ace-of-spades-display.6c21f0da.png";